<app-split-pane
  storageKey="split.optimization"
  [initialLeftRatio]="0.7"
  [collapseBreakpointPx]="1024"
  [collapsedOnSmallScreens]="true"
>
  <ng-container left>
    <app-split-pane-vertical storageKey="split.optimization.left" [initialTopRatio]="0.7">
      <ng-container top>
        <app-chat [suggestions]="optimizationSuggestions" [context]="optimizationContext" placeholder="Ask about performance, reliability, and cost..."></app-chat>
      </ng-container>
      <ng-container bottom>
        <app-history scopeKey="optimization.chat"></app-history>
      </ng-container>
    </app-split-pane-vertical>
  </ng-container>

  <ng-container right>
    <app-split-pane-vertical storageKey="split.optimization.right" [initialTopRatio]="0.7">
      <ng-container top>
        <div class="page-workspace">
          <section class="card shadow-sm border-0 p-3 p-md-4">
            <h2 class="h4 mb-1">Optimization</h2>
            <p class="text-muted mb-3">
              Define improvement objectives and rollout strategy for safe delivery gains.
            </p>
            <h3 class="h5 mb-3">Optimization Inputs</h3>
            <div class="row g-3">
              <div class="col-md-4">
                <label class="form-label">Optimization area</label>
                <select class="form-select" [(ngModel)]="optimizationDraft.area">
                  <option value="">Select area...</option>
                  @for (option of optimizationAreaOptions; track option) {
                    <option [value]="option">{{ option }}</option>
                  }
                </select>
              </div>
              <div class="col-md-4">
                <label class="form-label">Rollout strategy</label>
                <select class="form-select" [(ngModel)]="optimizationDraft.rolloutStrategy">
                  <option value="">Select rollout...</option>
                  @for (option of rolloutStrategyOptions; track option) {
                    <option [value]="option">{{ option }}</option>
                  }
                </select>
              </div>
              <div class="col-md-4">
                <label class="form-label">Objective</label>
                <input class="form-control" [(ngModel)]="optimizationDraft.objective" placeholder="e.g. Reduce API p95 to < 300ms" />
              </div>
            </div>
            <div class="mt-3">
              <button class="btn btn-primary" type="button" [disabled]="creatingPlan" (click)="createOptimizationPlan()">
                @if (creatingPlan) {
                  <span class="spinner-border spinner-border-sm me-2"></span>
                  Creating...
                } @else {
                  Create Optimization Plan
                }
              </button>
            </div>
            @if (optimizationError) {
              <div class="alert alert-danger mt-3 mb-0">{{ optimizationError }}</div>
            }
            @if (optimizationSuccess) {
              <div class="alert alert-success mt-3 mb-0">{{ optimizationSuccess }}</div>
            }
          </section>

          <section class="card shadow-sm border-0 p-3 p-md-4">
            <h3 class="h5 mb-3">Plan Summary</h3>
            @if (!hasCreatedPlan) {
              <div class="small text-muted">No plan created yet. Create an optimization plan to populate summary.</div>
            } @else {
              <div class="summary-grid">
                <article class="summary-card">
                  <div class="summary-label">Area</div>
                  <div class="summary-value">{{ optimizationDraft.area }}</div>
                </article>
                <article class="summary-card">
                  <div class="summary-label">Rollout</div>
                  <div class="summary-value">{{ optimizationDraft.rolloutStrategy }}</div>
                </article>
                <article class="summary-card summary-card--full">
                  <div class="summary-label">Objective</div>
                  <div class="summary-value">{{ optimizationDraft.objective }}</div>
                </article>
              </div>
            }
          </section>
        </div>
      </ng-container>
      <ng-container bottom>
        <app-history scopeKey="optimization.main"></app-history>
      </ng-container>
    </app-split-pane-vertical>
  </ng-container>
</app-split-pane>
